import React, {useEffect, useState} from 'react';
import { useSelector } from 'react-redux';
import { calculateCS, formatData } from '../helpers/monitor';
import { fetchEstimator } from '../api/monitor';

import Monitor from '../components/Monitor';

const Estimator = (props) => {
  const parentsInfo = useSelector((state) => state.parents);
  const childrensInfo = useSelector((state) => state.childrens);
  const section = useSelector((state) => state.ui.updateSection);
  const { parents } = parentsInfo;

  const [ parentsPayment, setParentsPayment ] = useState([0,0]);


  const updatePayments = (CS,variables, firstParentBigger) => {
  
    const { CM, TN, H, K} = variables;

    if (H.averageTimeParent1 === H?.averageTimeParent2){
      setParentsPayment((
        firstParentBigger ? [CS.parent1,0] : [0,CS.parent2]
        ));
        return;
    }
    setParentsPayment((CS.parent1>=CS.parent2?[CS.parent1,0]:[0,CS.parent2]));
  }


  useEffect(() => {
    const {CS, variables} = calculateCS(parentsInfo,childrensInfo);
    updatePayments(CS, variables, variables.TN.disponsableIncomeParent1 >= variables.TN.disponsableIncomeParent2);
  }, [parentsInfo,childrensInfo])


  useEffect(() => {
    const fetchData = async () => {
      const res = await fetchEstimator(formatData(parentsInfo,childrensInfo));
      const {CS, variables} = calculateCS(parentsInfo,childrensInfo);
      if (Math.abs(res.data.CS.parent1 - CS.parent1) > 0.1 || Math.abs(res.data.CS.parent2 - CS.parent2) > 0.1){
        updatePayments(res.data.CS,res.data.variables,variables.TN.disponsableIncomeParent1 >= variables.TN.disponsableIncomeParent2);
      }
    }
    fetchData().catch(console.error);
  }, [section])
  


  return (
    <Monitor extraClassName={props.extraClassName} headerHeight={props.headerHeight} parents={parents} parentsPayment={parentsPayment} style={props.style}/>
  )
}

export default Estimator;

